<script lang="ts">
	import type { Snippet } from "svelte";

	const {
		children,
		class: className = "",
		element = "div",
		...restProps
	}: {
		children: Snippet;
		class?: string;
		element?: "div" | "section" | "header" | "article";
	} & Record<string, unknown> = $props();

	// Sticky pouze na lg+ s top offsetem pro výšku menu (88px)
	// Na menších obrazovkách normální chování
	const stickyClasses = "lg:sticky lg:top-[88px] lg:self-start";
</script>

<svelte:element this={element} class="{stickyClasses} {className}" {...restProps}>
	{@render children()}
</svelte:element>
